import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/app/services/core/odata'
import { ODataService } from 'common-services'

export class IMarketChannel {
  Id: number
  ScreeningChannelLink: string
  AdmissionChannelLink: string
  RehabAdmissionChannelLink: string
}

@Injectable()
export class MarketChannelODataService extends ODataService<IMarketChannel> {
  constructor(protected http: HttpClient, protected config: SmODataConfiguration) {
    super(http, config)
    this.typeName = 'MarketChannels'
  }
}
